"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventBackLink = exports.useGetEventFromHistoryLink = exports.useGetEventCompletedLink = exports.useGetEventLink = exports.getEventBackLink = exports.getEventCompletedLink = exports.getBetEventLink = exports.getEventLink = exports.getLineTournamentLink = exports.getLinkToLine = exports.getLinkToLive = void 0;
const api_1 = require("betweb-openapi-axios/dist/api");
const react_router_dom_1 = require("react-router-dom");
const react_1 = require("react");
const utils_1 = require("astra-core/containers/ConfigProvider/utils");
const types_1 = require("astra-core/containers/ConfigProvider/types");
function getLinkToLive({ sportId, eventId }) {
    return `/live/${sportId}/${eventId}`;
}
exports.getLinkToLive = getLinkToLive;
function getLinkToLine({ sportId, eventId }) {
    return `/line/${sportId}/events/${eventId}`;
}
exports.getLinkToLine = getLinkToLine;
function getLineTournamentLink(tournament) {
    return `/line/${tournament.sportId}/${tournament.id}`;
}
exports.getLineTournamentLink = getLineTournamentLink;
function getEventLink(event, isLinkedEnabled = false) {
    const { sportId } = event.tournament;
    let eventId = event.id;
    if (isLinkedEnabled &&
        event.baseEventId !== null &&
        event.baseEventId !== undefined) {
        eventId = event.baseEventId;
    }
    if (event.live) {
        return getLinkToLive({ sportId, eventId });
    }
    return getLinkToLine({ sportId, eventId });
}
exports.getEventLink = getEventLink;
function getBetEventLink(event) {
    if (event === undefined)
        return '';
    const { sportId } = event;
    const eventId = event.id;
    if (event.live) {
        return getLinkToLive({ sportId, eventId });
    }
    return getLinkToLine({ sportId, eventId });
}
exports.getBetEventLink = getBetEventLink;
function getEventCompletedLink(event, sportId) {
    if (event === undefined)
        return '';
    return event.status !== api_1.EventStatus.Ended &&
        event.status !== api_1.EventStatus.Closed
        ? getLinkToLive({ sportId, eventId: event.id })
        : `/results/${sportId}/${event.id}`;
}
exports.getEventCompletedLink = getEventCompletedLink;
function getEventBackLink(event, prevPath, sportId) {
    if (prevPath !== undefined) {
        return prevPath;
    }
    if (event.live) {
        return `/live/${sportId !== null && sportId !== void 0 ? sportId : event.tournament.sportId}`;
    }
    return getLineTournamentLink(event.tournament);
}
exports.getEventBackLink = getEventBackLink;
const useGetEventLink = ({ event, routesWithoutPrevPath, }) => {
    const location = (0, react_router_dom_1.useLocation)();
    const isLinkedEventsEnabled = (0, utils_1.useFeatureFlag)(types_1.EFeatureFlags.LINKED_EVENTS_ENABLED);
    const link = getEventLink(event, isLinkedEventsEnabled);
    const state = (0, react_1.useMemo)(() => {
        let state;
        if (!(routesWithoutPrevPath === null || routesWithoutPrevPath === void 0 ? void 0 : routesWithoutPrevPath.includes(location.pathname))) {
            state = {
                prevPath: location.pathname,
            };
        }
        const isLinkedEvent = Boolean(event.baseEventId);
        if (isLinkedEvent && isLinkedEventsEnabled) {
            state = Object.assign(Object.assign({}, state), { linkedEventId: event.id });
        }
        return state;
    }, [
        event.baseEventId,
        event.id,
        isLinkedEventsEnabled,
        location.pathname,
        routesWithoutPrevPath,
    ]);
    return (0, react_1.useMemo)(() => ({
        pathname: link,
        state,
    }), [link, state]);
};
exports.useGetEventLink = useGetEventLink;
const useGetEventCompletedLink = ({ event, sportId, }) => {
    const location = (0, react_router_dom_1.useLocation)();
    const link = getEventCompletedLink(event, sportId);
    return (0, react_1.useMemo)(() => ({
        pathname: link,
        state: event.status !== api_1.EventStatus.Ended &&
            event.status !== api_1.EventStatus.Closed
            ? { prevPath: location.pathname }
            : undefined,
    }), [link, location.pathname, event.status]);
};
exports.useGetEventCompletedLink = useGetEventCompletedLink;
const useGetEventFromHistoryLink = ({ event, routesWithoutPrevPath, }) => {
    const location = (0, react_router_dom_1.useLocation)();
    const link = getBetEventLink(event);
    return (0, react_1.useMemo)(() => ({
        pathname: link,
        state: (routesWithoutPrevPath === null || routesWithoutPrevPath === void 0 ? void 0 : routesWithoutPrevPath.includes(location.pathname))
            ? undefined
            : { prevPath: location.pathname },
    }), [link, location.pathname, routesWithoutPrevPath]);
};
exports.useGetEventFromHistoryLink = useGetEventFromHistoryLink;
const useEventBackLink = ({ event, sportData, routesWithoutPrevPath, }) => {
    var _a;
    const history = (0, react_router_dom_1.useLocation)();
    const isGenericSportsEnabled = (0, utils_1.useFeatureFlag)(types_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
    const link = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        const prevPath = (routesWithoutPrevPath === null || routesWithoutPrevPath === void 0 ? void 0 : routesWithoutPrevPath.includes((_a = history.state) === null || _a === void 0 ? void 0 : _a.prevPath))
            ? undefined
            : (_b = history.state) === null || _b === void 0 ? void 0 : _b.prevPath;
        if (isGenericSportsEnabled && sportData !== undefined) {
            return getEventBackLink(event, prevPath, (_c = sportData.genericSportId) !== null && _c !== void 0 ? _c : sportData.id);
        }
        else {
            return getEventBackLink(event, prevPath);
        }
    }, [
        event,
        (_a = history.state) === null || _a === void 0 ? void 0 : _a.prevPath,
        isGenericSportsEnabled,
        sportData,
        routesWithoutPrevPath,
    ]);
    return link;
};
exports.useEventBackLink = useEventBackLink;
//# sourceMappingURL=events.js.map